import React from "react";
import MenuButton from "./MenuButton";

const SubIntents = ({ payload, actions }) => {
  return (
    <div>
      {payload?.subIntents?.map((subIntent, index) => (
        <button
          key={index}
          onClick={() =>
            actions.handleSubIntentSelection(subIntent, payload?.intent)
          }
          className="border border-customBlue hover:bg-gray-100 py-0.5 px-3 m-1 rounded-full"
        >
          {subIntent}
        </button>
      ))}
      <MenuButton actions={actions} />
    </div>
  );
};

export default SubIntents;
